import React from "react";
import "./AboutWork.scss";

import { ReactComponent as AboutWork1 } from "../../assets/svg/aboutWork1.svg";
import { ReactComponent as AboutWork2 } from "../../assets/svg/aboutWork2.svg";
import { ReactComponent as AboutWork3 } from "../../assets/svg/aboutWork3.svg";
import { ReactComponent as AboutWork4 } from "../../assets/svg/aboutWork4.svg";

const workItems = [
  { icon: <AboutWork1 />, text: "Project kickoff" },
  { icon: <AboutWork2 />, text: "Discover" },
  { icon: <AboutWork3 />, text: "Design & Develop" },
  { icon: <AboutWork4 />, text: "Implementation" },
];

const AboutWork = () => {
  return (
    <section className="section aboutWork" id="aboutSection">
      <article className="aboutWork__container container">
        <div className="aboutWork__container--header">
          <div className="aboutWork__header-title">
            <h2 className="aboutWork__title">How</h2>
            <h3 className="aboutWork__subtitle">We Work</h3>
          </div>

          <div className="aboutWork__header-desc">
            <AboutWork2 />
            <p>
              Our process is simple. We start with your needs, create engaging
              experiences, research, experiment with ideas, and use your
              feedback to guide us.
            </p>
          </div>
        </div>

        <div className="aboutWork__container--contents">
          {workItems.map((item, index) => (
            <div key={index} className="aboutWork__contents-items">
              {item.icon}
              <p>{item.text}</p>
            </div>
          ))}
        </div>
      </article>
    </section>
  );
};

export default AboutWork;
